<template>
  <div>
    <template v-if="!stidlistLengthStatus">
      <lida-table
        :propscolumns="columns(false)"
        :data="totalItems"
        :sortStatus="false"
        align="right"
        :SpinLoading="loading"
        :propsPageSize="50"
        :mytlpa="mytlpa"
        class="my-2"
        :LeaveSpace="false"
      >
        <template v-slot:headerSelect>
          <p class="title text-left">全部</p>
        </template>
      </lida-table>
      <lida-table
        v-for="(it, key) in totalData"
        :key="key"
        :propscolumns="columns(true, key)"
        :data="it"
        :sortStatus="false"
        align="right"
        :SpinLoading="loading"
        :propsPageSize="50"
        class="my-2"
        :LeaveSpace="false"
        :page="false"
        :mytlpa="mytlpa"
      >
        <template v-slot:headerSelect>
          <p class="title text-left">{{getGamename(key)}}</p>
        </template>
      </lida-table>
    </template>
    <template v-else>
      <RateTotal
        :rateData="rateData"
      />
      <template v-for="it in sitedata">
        <lida-table
          :propscolumns="columns(false)"
          :data="it.data"
          :sortStatus="false"
          align="right"
          :SpinLoading="loading"
          :propsPageSize="50"
          class="my-2"
          :LeaveSpace="false"
          :mytlpa="it.mytlpa"
        >
          <template v-slot:headerSelect>
            <p class="title text-left">{{it.stname}}</p>
          </template>
        </lida-table>
      </template>
    </template>
  </div>
</template>
<script>
import switchHie from "../mixins/switchHie.js"
import reportCount from '@/mixins/report-count.js'
import { mapGetters, mapActions } from 'vuex';
import RateTotal from '@/views/ledger/general-ledger/rateTotal.vue'
export default {
  name: 'reporta1',
  mixins: [reportCount, switchHie],
  components: {
    RateTotal
  },
  data () {
    return {
      totalData: {},
      tableData: [],
      notSunArray: ['hie', 'iscash1', 'mid', 'memcou', 'l2username', 'l2name', 'l2uppspa', 'l1total'],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getAllGame'])
  },
  created () {
    this.searchDate()
  },
  methods: {
    async searchDate () {
      this.loading = true
      try {
        const mytlpaData = await this.$axios.liveshow.linkmytlpa(this.query.stidlist)
        let res = await this.$axios.generalLedger.linkreporta1(this.query)
        if ('status' in res && res.status === 0) return
        if (!this.stidlistLengthStatus) {
          this.totalData = { ...this.itemsDefault(), ...res[0].data }
          const obj = this.sunl1total(res[0].data, 'l2upps')
          this.sunTotal({ l1total: obj.l1totalAll, name: 'l2name', name2: 'l2username' })
          this.mytlpa = mytlpaData[0].mytlpa
        } else {
          mytlpaData.forEach(item => {
            let index = res.findIndex(items => items.stname == item.memname)
            if (index !== -1) {
              res[index].mytlpa = item.mytlpa
            }
          });
          this.getSitedata(res)
        }
        this.itemsSort()
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    columns (status = true, gameid) {
      const object = {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 50
        },
        l2name: {
          title: '分公司',
          align: 'center',
          key: 'l2name',
          totaltext: '总计',
          notetext: '本占比总计',
          width: 200,
          render: (h, params) => {
            if (this.checkFooterText(params.row.l2name)) {
              return params.row.l2name == '本占比总计'
                ? h('span', `${params.row.l2name} (${this.mytlpa}%)`)
                : h('span', params.row.l2name)
            } else {
              return h(this.stidlistLengthStatus ? 'p' : 'a', {
                on: {
                  click: () => this.stidlistLengthStatus ? null : this.$router.push({
                    name: `general-ledger-reporta${params.row.hie}`,
                    query: { ...this.$route.query, mid: params.row.mid, lastLevel: 1 },
                    params: { scrollGameid: gameid }
                  })
                }
              },
                [
                  h('span', { class: { pc3: true } }, params.row.l2name),
                  h('span', { class: { pc2: true } }, ` ${params.row.l2username}`)
                ])
            }

          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          total: true,
          minWidth: 2,
          render: (h, params) => h('span', this.$commaFormat(params.row.cou))
        },
        memcou: {
          title: '会员数',
          align: 'center',
          key: 'memcou',
          total: true,
          width: 80
        },
        value: {
          title: '下注金额',
          align: 'center',
          key: 'value',
          total: true,
          note: true,
          width: 100,
          render: (h, params) => this.renderColorAmount(h, params, 'value')
        },
        effval: {
          title: '有效额',
          align: 'center',
          key: 'effval',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => {
            const value = params.row.effval * -1
            return h('span', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        bonus: {
          title: '会员奖金',
          align: 'center',
          key: 'bonus',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => {
            const value = params.row.mpaysum - params.row.payds
            return h('span', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        payds: {
          title: '会员佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        mpaysum: {
          title: '会员盈亏',
          align: 'center',
          key: 'mpaysum',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'mpaysum')
        },
        l2upps: {
          title: '分公司占成上缴',
          align: 'center',
          key: 'l2upps',
          total: true,
          note: true,
          width: 120,
          render: (h, params) => this.renderColorAmount(h, params, 'l2upps')
        },
        l2uppspa: {
          title: '分公司上缴(%)',
          align: 'center',
          key: 'l2uppspa',
          width: 120,
          render: (h, params) => {
            const l1total = params.row.l1total
            return !this.checkFooterText(params.row.l2name) ? h('p', `${params.row.l2upps > 0 ? ((params.row.l2upps / l1total) * 100).toFixed(2) : 0}%`) : null
          },
        },
        l2upt: {
          title: '分公司上缴',
          align: 'center',
          key: 'l2upt',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l2upt')
        },
        l1p: {
          title: '公司占成%',
          align: 'center',
          key: 'l2uppspa',
          total: true,
          render: (h, params) => {
            const value = params.row.effval != 0 ? ((params.row.l1pays / params.row.effval) * 100).toFixed(2) : 0
            return !this.checkFooterText(params.row.l2name) ? h('span', `${value}%`) : null
          },
        },
        l1pays: {
          title: '公司占成',
          align: 'center',
          key: 'l1pays',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1pays')
        },
        l1paysumt: {
          title: '公司占成盈亏',
          align: 'center',
          key: 'l1paysumt',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1paysumt')
        },
        mid: {
          title: '公司补货奖金',
          align: 'center',
          key: 'mid',
          total: true,
          note: true,
          render: (h, params) => {
            return h('span', 0)
          },
        },
        bupayds: {
          title: '公司补货佣金',
          align: 'center',
          key: 'bupayds',
          total: true,
          note: true,
        },
        l1pds: {
          title: '公司赚佣',
          align: 'center',
          key: 'l1pds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1pds')
        },
        l1paysum: {
          title: '公司盈亏',
          align: 'center',
          key: 'l1paysum',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1paysum')
        }
      }
      if (!status) delete object.memcou
      return object
    },
  }
};
</script>